import { useEffect } from "react";
import { create } from "zustand";

export type LoaderState = {
  visible: Record<string, boolean>;

  setVisible: (key: string, visable: boolean) => void;
  clear: () => void;
};

export const useLoaderState = create<LoaderState>((set) => ({
  visible: {},
  setVisible: (key: string, visible: boolean) => {
    set((prev) => ({ visible: { ...prev.visible, [key]: visible } }));
  },

  clear: () => set({ visible: {} }),
}));

export const useLoader = (key: string, visable: boolean) => {
  const { setVisible: setVisable } = useLoaderState();

  useEffect(() => {
    setVisable(key, visable);

    return () => {
      setVisable(key, false);
    };
  }, [visable, key, setVisable]);
};
